import { useQuery as o } from "@tanstack/vue-query";
import { computed as r, toValue as t } from "vue";
import { SUPPRESS_ERROR_TOAST_META as c } from "../../error-handling/constants.js";
import "@hprofits/utils";
import "@hprofits/shared/errors";
import "@orpc/contract";
import "../../errors/utils.js";
const u = ["blacklist-auto-rule"], a = {
  all: u,
  list: (e) => [...u, "list", e],
  detail: (e) => [...u, "detail", e],
  sspTargets: (e) => [...u, "ssp-targets", e],
  sspTargetsPreview: (e) => [...u, "ssp-targets-preview", e]
}, g = (e, s, l) => o({
  ...c,
  ...l,
  queryKey: r(() => a.sspTargets(t(s))),
  enabled: r(() => t(s).ruleIds.length > 0),
  queryFn: () => e.blacklistAutoRule.sspTargets(t(s))
}), k = (e, s, l) => o({
  ...c,
  ...l,
  queryKey: r(() => a.sspTargetsPreview(t(s))),
  enabled: r(() => t(s).adUnitIds.length > 0 || t(s).adUnitTypeIds.length > 0),
  queryFn: () => e.blacklistAutoRule.sspTargetsPreview(t(s))
}), m = (e, s, l) => {
  const i = r(() => a.list(t(s)));
  return o({
    ...l,
    queryKey: i,
    queryFn: async () => e.blacklistAutoRule.findAll(t(s))
  });
}, q = (e, s, l) => {
  const i = r(() => a.detail(t(s).ruleId));
  return o({
    ...l,
    queryKey: i,
    queryFn: async () => e.blacklistAutoRule.findOne({ ruleId: t(s).ruleId })
  });
}, b = async (e, s, l) => {
  await e.prefetchQuery({
    queryKey: a.list(l),
    queryFn: async () => s.blacklistAutoRule.findAll(l)
  });
};
export {
  a as blacklistAutoRuleKeys,
  b as prefetchBlacklistAutoRules,
  q as useBlacklistAutoRule,
  m as useBlacklistAutoRules,
  g as useBlacklistSspTargets,
  k as useBlacklistSspTargetsPreview
};
//# sourceMappingURL=queries.js.map
